import { boot } from 'quasar/wrappers';
import { setClientId } from 'services/api';
import useWebsocket from 'composables/websocket';

export default boot(async () => {
  const { connect, ws } = useWebsocket();
  void connect();
  ws.on('clientId', (clientId) => {
    setClientId(<string>clientId);
  });
  await ws.ready();
});
